export default __webpack_public_path__ + "static/media/order_selected.e2d0f4a7.svg";